import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow, LEADERS } from "./shared";

export const LeadershipTeaser = () => {
  const navigate = useNavigate();

  return (
    <section
      id="leadership"
      data-testid="leadership-section"
      className="relative pt-0 pb-28 lg:pb-40"
      style={{ backgroundColor: "#FAF9F7" }}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <Reveal
          className="rounded-lg p-8 sm:p-12 lg:p-16"
          style={{ backgroundColor: "#F2F1EF", border: "1px solid #D8D8D8" }}
        >
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
            {/* Left: heading */}
            <div className="lg:col-span-5">
              <Eyebrow>Leadership</Eyebrow>
              <h2 className="font-bold leading-[1.08] text-3xl sm:text-4xl lg:text-5xl" style={{ color: "#2B2B2B" }}>
                A Legacy That<br />
                <span style={{ color: "#3B2C82" }}>Continues to Build</span>
              </h2>
            </div>

            {/* Right: body + names + cta */}
            <div className="lg:col-span-7">
              <p className="text-base lg:text-lg leading-relaxed max-w-2xl" style={{ color: "#8C8C8C" }}>
                Fortim Ventures is built on more than a business plan — it is built on a legacy of
                entrepreneurship that has been part of DNHDD for over a century. Since 1924, the
                Fugro family has contributed to the region through business, hospitality, industry
                leadership and community initiatives.
              </p>

              <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-6">
                {LEADERS.map((l) => (
                  <div key={l.name} data-testid={`leadership-name-${l.initials.toLowerCase()}`}>
                    <span className="h-px w-8 block mb-4" style={{ background: "#F5821F" }} />
                    <p className="text-lg font-bold" style={{ color: "#2B2B2B" }}>{l.name}</p>
                    <p className="text-sm mt-1" style={{ color: "#8C8C8C" }}>{l.role}</p>
                  </div>
                ))}
              </div>

              <button
                data-testid="meet-leadership-btn"
                onClick={() => navigate("/leadership")}
                className="group mt-12 inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full text-sm font-semibold text-white transition-colors duration-300"
                style={{ backgroundColor: "#3B2C82" }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#6B5CA5")}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#3B2C82")}
              >
                Meet Our Leadership
                <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
